import DeletedLogList from './DeletedLogList'

export default DeletedLogList;